require('./gapAccessView.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, getLanguage } = require('core/i18n').i18n;
// @ components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox.js');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const {WIZARD_VERTICAL_VIEW_MODE} = require('constants/index');
const GapAccessStepOne = require('./gapAccessStepOne/gapAccessStepOne');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
// @ constants
const { GAP_OPERATION_ID } = require('constants/contactCenter/operationTypes');
const { GAP_RAISEN2_OK } = require('constants/contactCenter/gapUrl');
const {
    TRANSLATION_PLATFORM_PRI,
    TRANSLATION_PLATFORM_CC
} = require('constants/translations');
const { DALI_OPTION_GAP_ACCESS } = require('constants/flagBasedFeatures')
// @ utilities
const usd = require('utilities/usd');

class GapAccessView extends React.Component {
     constructor(props){
         super(props);
         this.handleFinish = this.handleFinish.bind(this);
         this.handleGoBack = this.handleGoBack.bind(this);
    }

    componentDidMount() {
        const {requestTranslations} = this.props;
        requestTranslations(__CONTACT_CENTER__ ? TRANSLATION_PLATFORM_CC : TRANSLATION_PLATFORM_PRI, getLanguage());
    }

    componentWillUnmount() {
        const { resetWizard, resetRaiseN2 } = this.props;
        resetWizard();
        resetRaiseN2();
    }

    handleGoBack() {
        const { resetWizard, resetRaiseN2 } = this.props;
        resetWizard();
        resetRaiseN2();
    }

    buildError() {
        const title = formatText('gapAccess-errorTitle');
        const extraContent = (
            <div className="gap-access__extra-content">
                <BlockInfo>{formatText('gapAccess-errorMessage')}</BlockInfo>
            </div>
        );
        const textLink = formatText('gapAccess-returnText').toUpperCase();
        const goBackHandler = this.handleGoBack;
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                extraContent={extraContent}
                textLink={textLink}
                goBackHandler={goBackHandler}
            />
        )
    }

    buildSucces() {
        return (
            <CustomMessageBox
                icon="icon-success"
                title={formatText('gapAccess-successTitle')}
            />
        )
    }

    handleFinish() {
        const { handleFinish } = this.props;
        handleFinish();
    }

    checkingError() {
         const {immRaiseToN2} = this.props;
         const errorReceived = immRaiseToN2.get('errorReceived');
         const errorDescription = immRaiseToN2.getIn(['error', 'errorDescription']);

         return errorDescription !== 'Challenge validation error' && errorReceived;
    }

    buildWizard() {
        const { immGapAccess, setVisibleStep, validateStep, setOperative, immRaiseToN2, immFeatureFlags } = this.props;
        const immSteps = immGapAccess.get('steps');
        const gapSecurityDigits = immGapAccess.get('incompleteInputs');
        const isFetching = immRaiseToN2.get('isFetching');
        const stepsAmount = immSteps.size;
        let operativeState = immGapAccess.get('operative');
        const operative = !(operativeState.toJS().label) ? { value: operativeState.value , label: formatText('gapAccess-gapLabel') } : operativeState.toJS();
        const visibleStep = immGapAccess.get('visibleStep');
        const checkingError = immRaiseToN2.getIn(['error','errorDescription']) === 'Challenge validation error';
        const inlineVerifyOTPError = checkingError || gapSecurityDigits;
        const { isDisasterRecovery } = usd.getSecurityInfo();
        const daliOptionEnabled = immFeatureFlags.get(DALI_OPTION_GAP_ACCESS);
        // @keys
        const nextBtnLabel = 'gapAccess-confirmBtn';
        const operationParams = {};
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: () => {},
            finish: this.handleFinish,
            cancel: this.handleToggleCancelModal
        };

        const step1 =(
            <WizardStep
                position="first"
                cancelButton={false}
                isLoading={false}
                nextBtnModifier="primary">
                <GapAccessStepOne
                    operative={operative}
                    setOperative={setOperative}
                    daliOptionEnabled={daliOptionEnabled}
                />
            </WizardStep>)

        const step2 = (
            <WizardStep
                addLoadingBehaviour={true}
                cancelButton={false}
                immFinalButton={nextBtnLabel}
                isLoading={isFetching}
                omitPreviousButton={true}
                position="last"
                nextBtnModifier="primary"
                >
                <VerifyOtpStep
                    operationType={GAP_OPERATION_ID}
                    operationParams={operationParams}
                    invalidSecurityData={inlineVerifyOTPError}
                />
            </WizardStep>);

        const wizardProps = {
          actions,
          fullWidth:false,
          immSteps,
          stepsAmount,
          visibleStep,
          viewMode:WIZARD_VERTICAL_VIEW_MODE
        }
        let wizard = (
            <Wizard {...wizardProps}>
                {step1}
                {step2}
            </Wizard>
        )
        if(isDisasterRecovery){
            wizardProps.immSteps = immSteps.delete(0);
            wizardProps.stepsAmount = 1;
            wizard = (<Wizard {...wizardProps}>{step2}</Wizard>)
          }
        return wizard;
    }

    render () {
        const { immGapAccess, immRaiseToN2 } = this.props;
        const title = formatText('gapAccess-title');
        const raiseToN2error = immRaiseToN2.get('errorReceived');
        const errorReceived = this.checkingError();
        const actionCode =  immGapAccess.getIn(['operative', 'value']);
        const raiseToN2Trigger = immRaiseToN2.getIn(['response', 'status']);
        const { isDisasterRecovery } = usd.getSecurityInfo();

        let content;

        if(errorReceived) {
            content = this.buildError();
        } else if (isDisasterRecovery && raiseToN2Trigger === GAP_RAISEN2_OK) {
            content = this.buildSucces();
        }
        else {
            const wizard = this.buildWizard();
            content = (
                <div>
                    {wizard}
                </div>
            );
        }

        if(raiseToN2Trigger === GAP_RAISEN2_OK){
            const operationError = immGapAccess.get('errorReceived');
            const errorMessage = '';
            const newSecurityLevel= immRaiseToN2.getIn(['response', 'level']);
            if (isDisasterRecovery && newSecurityLevel !== usd.getSecurityLevel())
                {
                    usd.setSecurityLevel(newSecurityLevel);
                }
            usd.raiseN2( actionCode, operationError, errorMessage );
        }
        else if(!isDisasterRecovery && raiseToN2error) {
            const operationError = true;
            const errorMessage = immRaiseToN2.getIn(['error','error','description']);
            usd.raiseN2( actionCode, operationError, errorMessage );
        }

        return (
            <section className="gap-access">
                <OKHeaderCC
                    title={title}
                    showBreadBrumb={false}
                />

                <div className="gap-access__container">
                    {content}
                </div>
            </section>
        );
    }
}


GapAccessView.propTypes = {
    immGapAccess: PropTypes.object.isRequired,
    immRaiseToN2: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setOperative: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    resetWizard: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    resetRaiseN2: PropTypes.func.isRequired,
    requestTranslations: PropTypes.func.isRequired,
    immTranslations: PropTypes.object.isRequired,
    immFeatureFlags: PropTypes.object.isRequired,
};

module.exports = GapAccessView;
